/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Verification mode for push notification authentication.
 *
 * APPROVE_REJECT: User taps approve or reject on push notification
 * VISUAL_MATCH: User matches a visual pattern displayed on both devices
 */
export enum VerificationMode {
    APPROVE_REJECT = 'approve_reject',
    VISUAL_MATCH = 'visual_match',
}
